import { Image } from "ol/layer";
import ImageArcGISRest from "ol/source/ImageArcGISRest";
import { ServerLayer } from "../../../lib/layers";
import { Some } from "../../../lib/misc/option";
export class ImageLayer extends ServerLayer {
    constructor(opts) {
        super(opts);
    }
    get layers() {
        return this.raw.map(l => [l]).unwrapOr([]);
    }
    validate(opts) {
        let result = true;
        result && (result = typeof opts.infoUrl === 'string');
        result && (result = Array.isArray(opts.exportUrl) && opts.exportUrl.every(u => typeof u === 'string'));
        result && (result = opts.isBaseLayer !== undefined && opts.visible !== undefined);
        result && (result = typeof opts.isBaseLayer === 'boolean' && typeof opts.visible === 'boolean');
        return result;
    }
    async parse_config(opts) {
        var _a, _b;
        this.is_base = opts.isBaseLayer;
        this.name = opts.name;
        const api = await this.get_service_api(opts.exportUrl);
        if (!api) {
            console.error(`Image layer "${opts.name}" loading failed. See console logs.`);
            this.parsing_failed = true;
            return;
        }
        ;
        if (api.token) {
            opts.details = {
                ...opts.details,
                token: api.token
            };
        }
        const layer = new Image({
            extent: api.extent,
            opacity: opts.opacity,
            visible: opts.visible,
            source: new ImageArcGISRest({
                params: opts.details,
                url: api.endpoints.at(0),
                crossOrigin: 'anonymous',
                projection: api.projection,
            }),
        });
        this.raw = new Some(layer);
        this.projection = api.projection;
        (_a = layer.getSource()) === null || _a === void 0 ? void 0 : _a.on("imageloadstart", () => {
            this.display_loading_indicator(true);
        });
        (_b = layer.getSource()) === null || _b === void 0 ? void 0 : _b.on("imageloadend", () => {
            this.display_loading_indicator(false);
        });
    }
}
